import type {
    Capability,
    EventModel,
    EventSource,
    Outcome,
    Quote,
    SourceId,
} from './types';

export const SOURCES: Readonly<Record<SourceId, EventSource>> = {
    polymarket: {
        id: 'polymarket',
        label: 'Polymarket',
        capabilities: new Set<Capability>([
            'probability',
            'volume',
            'trades',
            'wallets',
            'flow',
        ]),
    },
};

export function sourceCan(source: SourceId, capability: Capability): boolean {
    return SOURCES[source].capabilities.has(capability);
}

export function eventCan(event: EventModel, capability: Capability): boolean {
    return event.sources.some(s => s.capabilities.has(capability));
}

export function quoteWith(
    outcome: Outcome,
    capability: Capability
): Quote | null {
    return outcome.quotes.find(q => sourceCan(q.source, capability)) ?? null;
}
